/// <reference path="../../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Nobox {

    export interface ProductPickerOptions {
        hideProducts?: string;
    }

    import fld = LeadRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ContactCheckGrid extends NoboxEntityGrid<LeadRow, ProductPickerOptions> {

        protected getColumnsKey() { return LeadColumns.columnsKey; }
        protected getDialogType() { return <any>LeadDialog; }
        protected getIdProperty() { return LeadRow.idProperty; }
        protected getLocalTextPrefix() { return LeadRow.localTextPrefix; }
        protected getService() { return LeadService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery, options: ProductPickerOptions) {
            super(container, options);

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getQuickFilters() {
            var flt = super.getQuickFilters();
            this.refresh();
            var filter1 = Q.first(flt, x => x.field == fld.ListId);
            filter1.handler = h => {
                const request = (h.request as LeadListRequest);
                const values = (h.widget as Serenity.ServiceLookupEditor).values;
                if (h.active) {
                    request.ListIds = values.map(x => Number(x));
                    request.ListIdPicker = this.options.hideProducts;
                    h.handled = true;
                } else {
                    request.ListIds = [];
                    request.ListIdPicker = this.options.hideProducts;
                    h.handled = true;
                }
            };
            var filter2 = Q.first(flt, x => x.field == LeadRow.Fields.Tags);
            filter2.handler = h => {
                const request = (h.request as LeadListRequest);
                const values = (h.widget as Serenity.ServiceLookupEditor).values;
                if (h.active) {
                    request.Tags = values.map(x => x);
                    request.ListIdPicker = this.options.hideProducts;
                    h.handled = true;
                } else {
                    request.Tags = [];
                    request.ListIdPicker = this.options.hideProducts;
                    h.handled = true;
                }
            };
            var filter3 = Q.first(flt, x => x.field == LeadRow.Fields.Category);
            filter3.handler = h => {
                const request = (h.request as LeadListRequest);
                const values = (h.widget as Serenity.StringEditor).value;
                if (h.active) {
                    request.ContainsField = "Category";
                    request.ContainsText = values;
                    request.ListIdPicker = this.options.hideProducts;
                    h.handled = true;
                }
            };

            return flt;
        }
        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            let lists = Q.getLookup("Nobox.ListLookup").itemById as unknown as ListRow[];

            Q.first(columns, x => x.field == fld.Category).format =
                ctx => `<a href="javascript:;" class="category-link">${Q.htmlEncode(ctx.value)}</a>`;
            Q.first(columns, x => x.field == fld.Tool).format =
                ctx => `<a href="javascript:;" class="tool-link">${Q.htmlEncode(ctx.value)}</a>`;
            Q.first(columns, x => x.field == fld.Country).format =
                ctx => `<a href="javascript:;" class="ctry-link">${Q.htmlEncode(ctx.value)}</a>`;
            Q.first(columns, x => x.field == fld.State).format =
                ctx => `<a href="javascript:;" class="stt-link">${Q.htmlEncode(ctx.value)}</a>`;
            Q.first(columns, x => x.field == fld.City).format =
                ctx => `<a href="javascript:;" class="cty-link">${Q.htmlEncode(ctx.value)}</a>`;
            Q.first(columns, x => x.field == fld.ListId).format =
                ctx => {
                    let idList = ctx.value;
                    if (!idList)
                        return "";

                    idList = idList.split(",") as number[]
                    var elList = "";
                    var idLast = 0;
                    idList.forEach(function (x) {
                        let g = lists[BigInt(x)] as any;
                        idLast = x;
                        if (!g) {
                            elList += `<span id="${x.toString()}" class="list-link">${x.toString()}, </span>`;
                        } else {
                            elList += `<span id="${x.toString()}" class="list-link">${Q.htmlEncode(g.Nm)}, </span>`;
                        }
                    });
                    if (lists[BigInt(idLast)]) {
                        return `<a href="javascript:;">${elList.replace(lists[BigInt(idLast)].Nm + ", ", lists[BigInt(idLast)].Nm)}</a>`;
                    } else {
                        return `<a href="javascript:;">${elList.replace(idLast.toString() + ", ", idLast.toString())} </a>`;
                    }
                };

            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }


        protected usePager() {
            return false;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != 'add-button');
            return buttons;
        }

        get selectedItems() {
            return this.rowSelection.getSelectedAsInt64().toString();
        }

        onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var request = this.view.params as LeadListRequest;
            //request.ColumnSelection = 1;
            if (this.options.hideProducts && this.options.hideProducts.length)
                request.ListIdPicker = this.options.hideProducts;

            return true;
        }
    }
}